import React, {useState} from 'react';
import {IconButton, Menu, MenuItem} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {useNavigate} from 'react-router-dom';
import {usePermissions} from "../../../hooks/usePermissions";
import {useAccessDeniedMessage} from "../../../hooks/useAccessDeniedMessage";
import {UPDATE_SUPPLIER} from "../../../constants/eInvoicePermissions";
import PermissionDeniedWrapper from "../../../components/PermissionDeniedWrapper";

const SupplierActionsMenu = ({supplier}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const {hasEInvoicePermission} = usePermissions();
    const accessDeniedMessage = useAccessDeniedMessage();
    const canEdit = hasEInvoicePermission(UPDATE_SUPPLIER);
    const navigate = useNavigate();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const onClickingDetails = () => {
        navigate('/suppliers/:id'.replace(':id', supplier.profile_id));
    };
    const onClickingEdit = () => {
        navigate('/suppliers/:id/edit'.replace(':id', supplier.profile_id));
    };

    return (
        <>
            <IconButton id="action-icon-button" onClick={handleClick} aria-label={'more'}>
                <MoreVertIcon/>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        style: {
                            boxShadow: '4px 4px 10px 0px rgba(0, 0, 0, 0.2)',
                        },
                    },
                }}
            >
                <MenuItem data-testid="details" key="details" onClick={onClickingDetails}>
                    {'Details'}
                </MenuItem>

                <PermissionDeniedWrapper show={!canEdit} title={accessDeniedMessage}>
                    <MenuItem data-testid="edit" disabled={!canEdit} key="edit" onClick={onClickingEdit}>
                        {'Edit'}
                    </MenuItem>
                </PermissionDeniedWrapper>
            </Menu>
        </>
    );
};

export default SupplierActionsMenu;
